module.exports = __webpack_public_path__ + "img/5-wire journal.a721a582.png";